<template>
  <div class="flex flex-col h-full justify-between">
    <div class="main flex flex-col flex-grow pb-20 sm:pb-10">
      <MainHeader />
      <div class="custom-container">
        <MainContent class="w-full"/>
      </div>
    </div>
    <footer class="main-footer min-h-152px bg-primary-100">
      <div class="custom-container h-full flex sm:flex-col sm:justify-center sm:space-y-4 justify-between items-center">
        <span v-if="$domain === 'ru'" class="text-white">
          {{ $t('landing.if-you-have-trouble-to-fill-form') }}
        </span>
        <span
          v-else
          class="text-white"
          v-html="$t('landing.if-you-have-trouble-to-fill-form-email')"
        />
        <div v-if="$domain === 'ru'" class="flex justify-between min-w-200px">
          <a
            href="https://vk.com/sm.career"
            class="flex items-center justify-center bg-white w-10 h-10 rounded-full bg-opacity-20"
            target="_blank"
          >
            <img src="@/assets/icons/vkontakte.svg" alt="vkontakte" />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import MainContent from '@/components/MainContent.vue';

export default {
  name: 'App',
  components: {
    MainHeader,
    MainContent,
  },
};
</script>

<style lang="scss">
.main {
  background-image: url('..//assets/images/main-bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
}
</style>
